module.exports = __webpack_public_path__ + "img/a8_05.a2bc2eb5.jpg";